import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import map from 'lodash/map';
import { SelectType } from '../../../utils/functions';
import { FilterList } from '../../AsideSearchBarAndContent/types';
import { FormStoreCity } from './Form';

interface Props {
  getValues: (type: keyof FilterList, values: any) => void;
  hasStore?: boolean;
  selected: any;
  localities: any;
  hasCity: boolean;
  changeLocality?: () => void;
  showStore?: boolean;
  typeSearch?: number;
}

export const StoreByCity = ({
  getValues,
  hasStore = true,
  selected,
  hasCity,
  localities,
  changeLocality,
  showStore = true,
  typeSearch,
}: Props) => {
  const handleSubmit = () => null;

  const [initialCity, setInitialCity] = useState<SelectType>();
  const [initialStore, setInitialStore] = useState<SelectType>();

  const cities = map(localities, (item: any) => {
    const itemSplited =
      typeof item === 'string' ? item.split('-') : Object.keys(item)[0].split('-');

    return {
      city: itemSplited[0],
      uf: itemSplited[1],
    };
  });

  useEffect(() => {
    if (selected && selected.city) {
      const initialCitySelected = `${selected.city.eq}-${selected.state.eq}`;
      setInitialCity({
        label: initialCitySelected,
        value: initialCitySelected,
      });
    }
  }, selected);

  if (hasCity && !initialCity) {
    const initialCitySelected = `${selected.city.eq}-${selected.state.eq}`;
    setInitialCity({
      label: initialCitySelected,
      value: initialCitySelected,
    });
  }

  if (hasStore && !initialStore) {
    const initialStoreSelected = selected.fantasyName.eq;

    setInitialStore({
      label: initialStoreSelected,
      value: initialStoreSelected,
    });
  }

  const renderForm = (props: any) => (
    <FormStoreCity
      title="formStoreCity"
      getValues={getValues}
      hasStore={hasStore}
      hasCity={hasCity}
      cities={cities}
      changeLocality={changeLocality}
      showStore={showStore}
      typeSearch={typeSearch}
      {...props}
    />
  );

  return (
    <Formik
      onSubmit={handleSubmit}
      initialValues={{ store: initialStore, city: initialCity }}
      render={renderForm}
      enableReinitialize
    />
  );
};
